import { render } from "./NewGroups.vue?vue&type=template&id=bb2023ce&scoped=true"
import script from "./NewGroups.vue?vue&type=script&lang=js"
export * from "./NewGroups.vue?vue&type=script&lang=js"

import "./NewGroups.vue?vue&type=style&index=0&id=bb2023ce&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb2023ce"]])

export default __exports__